import CandleHero from "../components/home/CandleHero";
import Marquee from "../components/home/Marquee";
import NeuroGame from "../components/home/NeuroGame";
import ComingSoon from "../components/home/ComingSoon";
import SeoIntro from "../components/home/SeoIntro";
import MeetTheTeam from "../components/home/MeetTheTeam";

export default function Home() {
    return (
        <div data-testid="home-page">
            <CandleHero />
            <Marquee />
            <MeetTheTeam />
            <NeuroGame />
            <ComingSoon />
            <SeoIntro />
        </div>
    );
}
